module.exports = __webpack_public_path__ + "success-point-dark.png?fe2e339341722b32970ec3c3c799ffa9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/confirm-point/success-point-dark.png
// module id = 1094
// module chunks = 0